import React, { useContext, useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
	return (
		<footer>
			<div className="container">
				<div className="row">
					<div className="col">
						<div className="credits-container py-4">
							<a target="_blank" className="mb-4 mx-4">
								<img src="/img/react-app/logo-oleario-orizzontale.png" /> 
							</a>
							<a target="_blank" className="mb-4 mx-4">
								<img src="/img/react-app/logo-crea.png" />
							</a>
							<a target="_blank" className="mb-4 mx-4">
								<img src="/img/react-app/logo-pac.png" />
							</a>
							<a target="_blank" className="mb-4 mx-4">
								<img src="/img/react-app/logo-ministero-agricoltura.png" />
							</a>
							<a target="_blank" className="mb-4 mx-4">
								<img src="/img/react-app/logo-UE.png" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;